import { Box, MenuItem, Typography, Select } from "@mui/material";

import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    marginTop: 12,
    // backgroundColor:'#fff'
  },
  label: {
    color: "#949494",
    marginBottom: 3,
  },
  customSelect: {
    backgroundColor: "#fff",
    color: "#949494",
    height: 35,
  },
}));

const CustomComboBox = ({
  label,
  onChange,
  items,
  value,
  prefix = "",
  prefixIndex = 0,
}) => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Typography variant={"h6"} className={classes.label}>
        {label}
      </Typography>
      <Select
        value={value}
        onChange={(e) => {
          // onChange(e.target.value);
          const selectedOption = items.find(
            (item) => item.value === e.target.value
          );
          onChange(e.target.value, selectedOption.id);
        }}
        variant={"outlined"}
        className={classes.customSelect}
      >
        {items.map((item, ind) => {
          return (
            <MenuItem key={ind} value={item.value}>
              {item.name + (prefixIndex <= ind ? prefix : "")}
            </MenuItem>
          );
        })}
      </Select>
    </Box>
  );
};

export default CustomComboBox;
